<div class="form-group">
  @if (showLabel && (question?.question_copy || question?.email_version || labelText)) {
    <label
      [innerHTML]="question?.question_copy || question?.email_version || labelText"
      class="form-group__label">
    </label>
  }
  @if (showSkip) {
    <div class="question-skip">
      <label class="custom-toggle custom-toggle--md custom-toggle--inline custom-toggle--transparent">
        <input
          type="checkbox"
          [checked]="skipped"
          [(ngModel)]="skipped"
          (ngModelChange)="onSkipChange()"
          name="add-note-toggle"
          id="skip-driver-details-toggle">
          <span class="custom-toggle__indi"></span>
          <span class="custom-toggle__label">Skip for now</span>
        </label>
      </div>
    }
    <!--Radio Pills-->
    @if (isRadio && !isUploadPills) {
      @for (item of items; track item) {
        <label class="custom-input custom-input--pill-buttons">
          <input
            type="radio"
            [name]="uniqueControlName"
            [value]="item?.answer ? item?.answer : item"
            (click)="checkOption()"
            [checked]="item?.answer === question?.answer || item === question?.answer || item === radioSelectedOption">
            <span class="custom-input__label">{{item?.answer ? item?.answer : item}}</span>
          </label>
        }
      }

      <!--Checkbox Pills-->
      @if (!isRadio && !isUploadPills) {
        @for (item of items; track item) {
          <label class="custom-input custom-input--pill-buttons">
            <input
              type="checkbox"
              [name]="uniqueControlName"
              [value]="item?.answer ? item?.answer : item"
              (click)="checkOption()"
              [checked]="item?.answer === question?.answer || item === question?.answer || checkIfItemIsChecked(item)">
              <span class="custom-input__label">{{item?.answer ? item?.answer : item}}</span>
            </label>
          }
        }

        @if (isUploadPills) {
          @for (item of items; track item) {
            <label class="custom-input custom-input--pill-buttons">
              <input
                type="checkbox"
                [name]="uniqueControlName"
                [id]="item.answer"
                (click)="addAreaContent(item)">
                <span class="custom-input__label"> +  {{item?.answer ? item?.answer : item}}</span>
              </label>
            }
          }
        </div>

